import {utils} from "./utils";

/**
 * Filters
 * @type {Element}
 */

const filters = document.querySelectorAll('.filter');

filters.forEach((el) => {

	// apre chiude il singolo filtro
	el.addEventListener('click', function (e) {
		e.stopPropagation();

		if (!e.target.classList.contains('filter__title'))
		{
			return false;
		}

		const filter = this;

		// reset other open filters
		const openFilters = document.querySelectorAll('.filter--open');

		openFilters.forEach((openFilter) => {
			if (openFilter !== filter)
			{
				openFilter.classList.remove('filter--open')
				openFilter.removeAttribute("data-lenis-prevent");
			}
		});

		if (filter.classList.contains('filter--open'))
		{
			// close filter
			filter.classList.remove('filter--open');
			filter.removeAttribute("data-lenis-prevent");
		}
		else
		{
			// open filter
			filter.classList.add('filter--open');
			filter.setAttribute("data-lenis-prevent", "true");
		}

		if (document.querySelectorAll('.filter--open').length > 0)
		{
			document.body.classList.add('filter-open');
		}
		else
		{
			setTimeout(function () {
				document.body.classList.remove('filter-open');
			}, 300);
		}

		filter.querySelector('.filter__values').removeAttribute('style');
	});
});


/**
 * ==========================================
 * Multi-filter system (OR inside, AND between)
 * ==========================================
 *
 * - Multiple values per data attribute (space separated)
 * - OR logic inside the same filter
 * - AND logic between different filters
 * - Re-evaluates every time a button is toggled
 */

/* --------------------------------------------------
   DOM REFERENCES
   -------------------------------------------------- */

const filterGroups = document.querySelectorAll(".filter-group");
const cards        = document.querySelectorAll(".card");


/* --------------------------------------------------
   FILTER STATE
   -------------------------------------------------- */

/**
 * Stores selected values for each filter group.
 * Keys are taken directly from the HTML data-filter attribute.
 */
const filterState = {};

filterGroups.forEach((group) => {
	const filterName = group.dataset.filter;
	filterState[filterName] = new Set();
});


/* --------------------------------------------------
  FILTER BUTTON HANDLING
   -------------------------------------------------- */

filterGroups.forEach((group) => {
	// Each group defines which filter it controls
	const filterName = group.dataset.filter;
	const filterCount = group.querySelector('.filter-count');

	group.querySelectorAll(".filter__values button").forEach((button) => {
		button.addEventListener("click", () => {
			const selectedValue = button.dataset.value;

			// Toggle visual state
			button.classList.toggle("selected");

			// Update filter state (add/remove value)
			toggleFilterValue(filterName, selectedValue);

			// Re-apply filtering logic
			applyFilters();

			if (filterCount !== null)
			{
				let filterCountValue = parseInt(filterCount.textContent);

				(button.classList.contains('selected'))? filterCountValue++ : filterCountValue--;

				filterCount.textContent = filterCountValue.toString();

				filterCount.style.opacity = (filterCountValue > 0)? 1 : 0;
			}
		});
	});
});


/* --------------------------------------------------
   STATE MANAGEMENT
   -------------------------------------------------- */

/**
 * Adds or removes a value from a filter Set.
 */
function toggleFilterValue(filterName, value) {
	const selectedValues = filterState[filterName];

	if (selectedValues.has(value))
	{
		selectedValues.delete(value);
	}
	else
	{
		selectedValues.add(value);
	}
}


/* --------------------------------------------------
   FILTERING LOGIC
   -------------------------------------------------- */

function applyFilters() {

	const postsContainer = document.querySelector(".posts-container");

	// Fade out everything
	postsContainer.classList.add("is-fading");

	// Wait for fade-out to complete
	setTimeout(() => {
		cards.forEach((card) => {

			let shouldShow = true;

			for (const filterName in filterState)
			{
				const selectedValues = filterState[filterName];

				// Skip filter if nothing selected
				if (selectedValues.size === 0)
				{
					continue;
				}

				const cardValues = (card.getAttribute(`data-${filterName}`) || "").split(" ");

				// Check if card matches at least one selected value (OR logic)
				const matches = [...selectedValues].some(value => cardValues.includes(value));

				if (!matches)
				{
					shouldShow = false;
					break;
				}
			}

			card.parentNode.classList.toggle("hidden", !shouldShow);
		});

		// Fade back in (only visible cards remain)
		postsContainer.classList.remove("is-fading");

	}, 600); // must match CSS transition duration
}